import apiGraph from "@/helpers/api/apiGraph";
import { useDocumentStore } from "@/stores/documents";

export default {
  // eslint-disable-next-line no-empty-pattern
  filesShareFile({}, payload) {
    const documentStore = useDocumentStore();

    return new Promise((resolve, reject) => {
      if (payload.qId.email) {
        payload.qId = { email: payload.qId.email };
      }

      apiGraph
        .post(`/me/drive/items/${payload.fileId}/invite`, {
          requireSignIn: true,
          sendInvitation: false,
          roles: payload.write ? ["write"] : ["read"],
          recipients: [payload.qId]
        })
        .then(async response => {
          response.data.value.map(p => {
            if (!p.grantedTo.user.id) {
              p.grantedTo.user.id = payload.qId.objectId;
            }
          });

          await documentStore.reloadDocumentPermissions(undefined, payload.fileId);

          resolve();
        })
        .catch(async () => {
          await documentStore.reloadDocumentPermissions(undefined, payload.fileId);

          reject();
        });
    });
  },

  // eslint-disable-next-line no-empty-pattern
  filesUnshareFile({}, payload) {
    const documentStore = useDocumentStore();

    return new Promise((resolve, reject) => {
      apiGraph
        .delete(`/me/drive/items/${payload.fileId}/permissions/${payload.permissionId}`)
        .then(() => {
          documentStore
            .reloadDocumentPermissions(undefined, payload.fileId)
            .then(() => {
              resolve();
            })
            .catch(() => resolve());
        })
        .catch(() => {
          documentStore.reloadDocumentPermissions(undefined, payload.fileId).then(() => {
            reject();
          });
        });
    });
  },

  filesFixSectionSharePermissions({ getters, dispatch }, payload) {
    dispatch("sections/loadMembersForSection", payload.sectionId, { root: true }).then(() => {
      const sectionMembers = getters["sections/MEMBERS"](payload.sectionId);

      const recipients = [
        ...sectionMembers.map(s => ({
          email: s.emailSchoolAddress
        }))
      ];

      apiGraph.post(`/me/drive/items/${payload.fileId}/invite`, {
        requireSignIn: true,
        sendInvitation: false,
        roles: ["read"],
        recipients: recipients
      });
    });
  }
};
